import { createAction, createErrorAction } from '../../../actions/actionCreator';
import { ActionsType } from '@card/types';

export enum BusinessActionType {
  Fetch = 'business/fetch',
  FetchSuccess = 'business/fetch_success',
  FetchError = 'business/fetch_error',
  PutName = 'business/put_name',
  PutNameSuccess = 'business/put_name_success'
}

/* eslint-disable @typescript-eslint/no-explicit-any */
export const BusinessActions = {
  fetch: () => createAction(BusinessActionType.Fetch),
  fetchSuccess: (business: any) => createAction(BusinessActionType.FetchSuccess, business),
  fetchError: (error: any) => createErrorAction(BusinessActionType.FetchError, error),
  putBusinessName: (businessParams: any) =>
    createAction(BusinessActionType.PutName, businessParams),
  putBusinessNameSuccess: (businessResponse: any) =>
    createAction(BusinessActionType.PutNameSuccess, businessResponse)
};
/* eslint-enable @typescript-eslint/no-explicit-any */

export type BusinessAction = ActionsType<typeof BusinessActions>;
